// extracted by mini-css-extract-plugin
export var author = "productItem-module--author--1f7c5";
export var category = "productItem-module--category--1e36d";
export var headline = "productItem-module--headline--52338";
export var headlinePost = "productItem-module--headline-post--84cbc";
export var highlighted = "productItem-module--highlighted--d5426";
export var image = "productItem-module--image--3ba59";
export var menuTitle = "productItem-module--menu-title--fd0a3";
export var paragraph = "productItem-module--paragraph--e50be";
export var titleName = "productItem-module--title-name--8ce66";